import { getDefaultStore } from 'jotai';
const jotaiStore = getDefaultStore();
export default jotaiStore;
//# sourceMappingURL=jotai-store.js.map